<template>
  <div id="app">
    <!--主题色-->
    <!-- <link rel="stylesheet" type="text/css" :href="this.$store.state.webCount.theme_color_url"/> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <ToTop></ToTop>
  </div>
</template>

<script>
import ToTop from "@/common/totop";
import store from "./vuex/store";
import Vue from "vue";
export default {
  name: "App",
  components: {
    ToTop
  },
  store,
  data() {
    return {
      is_show: false
    };
  },
  watch: {
    "$store.state.id_example": {
      handler: function(newVal, oldVal) {
        if (newVal != "") {
          this.$store.commit("userInfo");
          this.$store.commit("cartnum");
          this.$store.commit("classesdatas");
          this.getstate();
          this.getconfig();
          this.getAddress();
        }
      },
      deep: true
    }
  },
  created() {
    //在页面刷新时将vuex里的信息保存到localStorage里
    // window.addEventListener("beforeunload", () => {
    //   localStorage.setItem(
    //     "messageStore",
    //     JSON.stringify(this.$store.state)
    //   );
    // });
    //在页面加载时读取localStorage里的状态信息
    localStorage.getItem("messageStore1") &&
      this.$store.replaceState(
        Object.assign(
          this.$store.state,
          JSON.parse(localStorage.getItem("messageStore1"))
        )
      );
  },
  methods: {
    isWap() {
      const malltype = window.location.host.split(".")[0];
      return this.$api.post("redirect/index", { prefix: malltype }, res => {
        if (res.data.data.indexOf(window.location.host) == -1) {
          return;
          window.location.href = res.data.data;
        }
      });
    },
    //获取商城配置
    getstate: function() {
      this.$api.get(
        "sys/maintain",
        { id_example: this.$store.state.id_example },
        res => {
          if (res.data.code == "100") {
            this.$store.state.notice = res.data.data;
            if (res.data.data.status == 1) {
              //商城维护
              this.$router.push({ name: "Over" });
            } else {
            }
          }
        }
      );
    },
    getconfig: function() {
      this.$api.get(
        "sys/point",
        { id_example: this.$store.state.id_example },
        res => {
          this.$store.state.name = res.data.data.name;
        }
      );
    },
    getAddress() {
      var _this = this;
      this.$api.get(
        "user/address/list",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id
        },
        res => {
          if (res.data.code == "100") {
            console.log(res);
            res.data.data.forEach(item => {
              if (item.default == 1) {
                var json = {
                  area: [
                    item.province_str,
                    item.city_str,
                    item.county_str,
                    item.town_str
                  ],
                  id: [
                    item.province,
                    item.city,
                    item.county,
                    item.town ? item.town : 0
                  ]
                };
                localStorage.setItem("defalutAddress", JSON.stringify(item));
                this.$store.commit("setAddress", json);
                localStorage.setItem(
                  "messageStore1",
                  JSON.stringify(this.$store.state)
                );
              }
            });
          }
        }
      );
    }
  },
  async mounted() {
    await this.isWap();
    this.$store.commit("webInfo");
  },
  beforeCreate() {
    this.$store.commit("webInfo");
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.el-main {
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue